module.exports = __webpack_public_path__ + "img/unnamed.a75e43fb.jpg";